// Apolo IDE — root ErrorBoundary (bug-review Wave 1, P1).
//
// The ONLY error boundary in the app was ChatErrorBoundary, scoped to the
// conversation feed. A throw in AppShell, the sidebar, header, composer, the
// right rail, LoginPage, or any non-feed component unmounted the entire React
// tree to a blank screen with no recovery — regressing the documented invariant
// "tela preta = throw no render". This top-level boundary catches those throws,
// renders a recoverable fallback with a reload, and keeps the feed-scoped
// ChatErrorBoundary for granular in-conversation recovery.

import { Component } from 'react';

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary] render falhou no nível raiz', error, info?.componentStack);
  }

  reload = () => {
    try {
      window.location.reload();
    } catch {
      this.setState({ error: null });
    }
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        role="alert"
        className="flex min-h-screen w-full flex-col items-center justify-center gap-4 bg-apolo-bg px-6 text-center"
      >
        <div className="max-w-md rounded-apolo-lg border border-apolo-borderSubtle bg-apolo-surface1 p-6">
          <p className="text-base font-medium text-apolo-textPrimary">Algo quebrou ao desenhar a tela.</p>
          <p className="mt-2 text-sm text-apolo-textSecondary">
            O Apolo conteve o erro aqui em vez de mostrar uma tela preta. Recarregar costuma resolver — seu
            trabalho salvo (sessões, mensagens) está no servidor.
          </p>
          <pre className="mt-3 max-h-32 overflow-auto whitespace-pre-wrap break-words rounded-apolo-md bg-apolo-surface2 p-3 text-left text-xs text-apolo-textTertiary">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button
            type="button"
            onClick={this.reload}
            className="mt-4 inline-flex h-9 items-center rounded-apolo-md border border-apolo-borderSubtle px-4 text-sm font-medium text-apolo-textPrimary transition hover:bg-apolo-surface2 focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accent"
          >
            Recarregar o Apolo
          </button>
        </div>
      </div>
    );
  }
}
